import React, { useState } from "react";
import cn from "classnames";
import { ITabsMenuTabProps } from "@yandex-int/hr-components/TabsMenu/Tab/TabsMenu-Tab";
import styles from "./tab-menu.module.scss";


interface ITabMenuProps {
    className?: string;
    activeTab?: string;
    tabs: ITabsMenuTabProps[];
    onChange: (tabId: string) => void;
    justifyStart?: boolean;
}

export const TabMenu: React.FC<ITabMenuProps> = ({
                                                     className,
                                                     activeTab,
                                                     tabs,
                                                     onChange,
                                                     justifyStart
                                                 }) => {
    const [activeTabId, setActiveTabId] = useState<string | undefined>(activeTab);

    const onTabChange = (tabId: string) => {
        setActiveTabId(tabId);
        onChange(tabId);
    }

    return (
        <div className={cn(styles.wrapper, className, justifyStart ? styles.justifyStart : '')}>
            {tabs.map((tab) => (
                    <div className={cn(styles.tabItem, activeTabId === tab.id && styles.activeTabItem)} key={tab.id}
                         onClick={() => onTabChange(tab.id)}>{tab.content}</div>
                )
            )}
        </div>
    )
}
